@if(error) {
  <div class="alert alert-danger">{{error}}</div>
}
<div class="span9">
  <h1 data-automation-name="registrationIndex"> Registrations </h1>
</div>
<p class="lead">
  A Registration is a contract between a VEN and a VTN about what profile, protocol, and polling rate the VEN and VTN will use while communicating.
  Registrations created for 2.0a VEN are artificial but will set up the appropriate scheduled jobs.
  Registrations created for 2.0b VEN will be created after negotiating with the VTN.
</p>
@if(isAdmin) {
  <div class="span3" style="text-align:right;">
    <a id="createRegistration" class="btn btn-large btn-primary" (click)="nextPage($event, '/createRegistration', router)" style="margin-top:9px;"> Create Registrations</a>
  </div>
}
@if(isLoading) {
  <app-loader
    message="Loading Registrations...">
  </app-loader>
} @else {
  <table class="table table-striped">
    <thead>
    <tr>
      <th>Registration id</th>
      <th>VEN id</th>
      <th>VTN id</th>
      <th>Profile name</th>
      <th>Report only</th>
      <th>Mode</th>
      <th>Poll Rate</th>
      <th>Last Modified By</th>
      @if(isAdmin) {
        <th>Actions</th>
      }
    </tr>

    <!-- Search filter row -->
    <tr>
      <th><input placeholder="Registration ID" class="input-sm form-control" type="search" [(ngModel)]="registrationIdSearch" (input)="triggerSearch()"/></th>
      <th></th>
      <th></th>
      <th><input placeholder="Profile Name" class="input-sm form-control" type="search" [(ngModel)]="profileNameSearch" (input)="triggerSearch()"/></th>
      <th>
        <select class="input-sm form-control" [(ngModel)]="reportOnlySearch" (change)="triggerSearch()">
          <option value="">All</option>
          <option value="true">Yes</option>
          <option value="false">No</option>
        </select>
      </th>
      <th></th>
      <th></th>
      <th></th>
      @if(isAdmin) {
        <th></th>
      }
    </tr>
    </thead>
    <tbody>
      @for(registration of displayedRegistrations | paginate: paginationModel; track registration) {
        <tr class="table-active">
          <td>{{registration.registration_id}}</td>
          <td>{{registration.ven.ven_id}}({{registration.ven.id}})</td>
          <td>
            @for(vtn of registration.vtns; track vtn) {
              {{vtn.vtn_id + ' (' + vtn.id + ')'}}<br>
            }
          </td>
          <td>{{registration.profile_name}}</td>
          <td>{{registration.reportOnly}}</td>
          <td>
            <span class="badge badge-primary">
              {{ registration.mode | titlecase }}
            </span>
          </td>
          <td>{{registration.poll_rate}}</td>
          <td>{{registration.updated_by}}</td>

          @if(isAdmin) {
            <td>
              <div class="btn-group">
                <button id="cancel" class="btn btn-danger" type="button" (click)="delete(registration)">Cancel</button>
              </div>
            </td>
          }
        </tr>
      }

      @if(displayedRegistrations.length <= 0) {
        <tr>
          <td [attr.colspan]="isAdmin ? 8 : 7" style="text-align: center;"> No registrations found matching your search criteria.</td>
        </tr>
      }
    </tbody>
    <tfoot>
    <tr>
      <td class="text-center" [attr.colspan]="isAdmin ? 8 : 7">
        <pagination-controls [id]="paginationId" (pageChange)="handlePageChange($event)" class="my-pagination"></pagination-controls>
      </td>
    </tr>
    </tfoot>
  </table>
}
